// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__8-Ydn","cross":"Popup_cross__BI98X","shake":"Popup_shake__T7Vck","thanking":"Popup_thanking__7ebVQ","innerbox":"Popup_innerbox__W5DmX"};